import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles/styles.scss';


class PdpProductMetadata extends Component {
  get title() {
    // @todo remove the universalname if the pdp is decoupled.
    const title =  this.product.name || this.product.universalname || '';
    return (<span dangerouslySetInnerHTML = {{ __html: title }}></span>) ;
  }

  get product() {
    // @todo:refactor after decoupled pdp, only return product.
    return this.props.product ? this.props.product : this.props;
  }

  get subtitle() {
    const { descparttitle, descsectiontitle } = this.product;
    const titleAr = [];

    descparttitle && titleAr.push(descparttitle);
    descsectiontitle && titleAr.push(descsectiontitle);
    const subtitle = titleAr.join(', ');
    return !!subtitle ? (<span dangerouslySetInnerHTML = {{ __html: subtitle }}></span>) : '';
  }

  get tagline() {
    const { tagline } = this.product;
    return !!tagline ?  (<span dangerouslySetInnerHTML = {{ __html: tagline }}></span>) : '';
  }

  render() {
    return (
      <div className="pdp-product-metadata">
        <h1 className="header-pdp" data-test-id="header-productPage">
          {this.title}
          {!!this.product.isEbook && (
            <>
              {/*
                SEO wise the h1 needs a space between the title and ebook label
                We dont want it to be visible in frontend
              */}
              <span className="invisible-space">&nbsp;</span>
              <span className="header-pdp-ebook">
                {this.product.type}
              </span>
            </>
          )}
        </h1>
        {(!!this.subtitle || !!this.tagline) &&
          <h4 className="pdp-product-metadata-titel">
            { this.subtitle }
            { this.subtitle && this.tagline && <span> | </span>}
            { this.tagline }
          </h4>
        }
      </div>
    );
  }
}

PdpProductMetadata.propTypes = {
  /**
   * The store object
   */
  store: PropTypes.object,
  product: PropTypes.object,
};

export default PdpProductMetadata;
